import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import WhatsApp from "../assets/whatsapp.png";

import aboutHero from "../assets/train-sri-lanka.jpg";

function Contact() {

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Contact Us
                    </h1>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Contact our team and let us create the perfect Sri Lanka experience for you.
                    </p>
                </div>
            </section>

            {/* ================= MAP & OFFICE INFO ================= */}
            <section className="bg-white py-10 px-4">
                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">

                    {/* Google Map */}
                    <div data-aos="fade-right" className="w-full h-[500px] rounded-xl overflow-hidden shadow-lg">
                        <iframe
                            title="De Zoysa Travels & Tours Location"
                            src="https://www.google.com/maps?q=Mole%20Kade%20Gedara%2C%20Kanawa%2C%20Mahamookalanyaya%2C%20Sri%20Lanka&output=embed"
                            className="w-full h-full border-0"
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>

                    {/* Office Details */}
                    <div data-aos="fade-left" className="bg-gray-50 rounded-xl shadow-lg p-8 md:p-12">
                        <h3 className="text-2xl font-bold text-[#0b4c7d] mb-6">
                            De Zoysa Travels & Tours (Pvt.) Ltd.
                        </h3>

                        <div className="space-y-6 text-gray-700">

                            {/* Address */}
                            <div>
                                <p className="text-sm font-semibold text-gray-500 mb-1">ADDRESS</p>
                                <p>
                                    Mole Kade Gedara, Kanawa,<br />
                                    Mahamookalanyaya,<br />
                                    Sri Lanka.
                                </p>
                            </div>

                            {/* Phone */}
                            <div>
                                <p className="text-sm font-semibold text-gray-500 mb-1">PHONE</p>
                                <p>
                                    +94 75 080 0887
                                </p>
                            </div>

                            {/* Email */}
                            <div>
                                <p className="text-sm font-semibold text-gray-500 mb-1">EMAIL</p>
                                <p className="text-[#0b4c7d] font-medium">
                                    dezoysatravelsandtours@gmail.com
                                </p>
                            </div>

                            {/* Business Hours */}
                            <div>
                                <p className="text-sm font-semibold text-gray-500 mb-1">WORKING HOURS</p>
                                <p>
                                    Monday – Friday: 9.00 AM – 6.00 PM <br />
                                    Saturday: 9.00 AM – 1.00 PM
                                </p>
                            </div>

                        </div>
                    </div>

                </div>
            </section>

            <div className="fixed bottom-20 right-5 z-50">

                {/* ICON BUTTON */}
                <div
                    onClick={() => {
                        const dropdown = document.querySelector(".goog-te-gadget-simple");
                        if (dropdown) {
                            dropdown.click();
                        } else {

                        }
                    }}
                    className="w-14 h-14 bg-white rounded-full shadow-lg flex items-center justify-center cursor-pointer hover:scale-110 transition"
                >
                    <img
                        src="https://www.gstatic.com/images/branding/product/1x/translate_24dp.png"
                        alt="Translate"
                        className="w-7 h-7"
                    />
                </div>

                {/* HIDDEN GOOGLE TRANSLATE */}
                <div id="google_translate_element" className="absolute opacity-0 pointer-events-none"></div>

            </div>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94750800887"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default Contact;
